const language = () => {
  const switchers = document.querySelectorAll(".language");

  for (const switcher of switchers) {
    const select = switcher.querySelector("select");
    if (select) {
      select.selectedIndex = -1;
      select.addEventListener("change", () => {
        const index = select.selectedIndex - 1;
        const links = switcher.querySelector(".language-choices");
        links.children[index].querySelector("a").click();
      });
    }
  }
};

export default language;
